const blastView = 0 ; //process.env.EXPO_BLAST_VIEW === '1';
const oppText = 1 ;//process.env.EXPO_OPP_TEXT === '1';
const tattooCare = 0 ;//process.env.EXPO_TATTOO_CARE === '1';
const whistlePitch = !blastView && !oppText && !tattooCare;


console.log('test ', process.env.EXPO_OPP_TEXT )

const brand: "WhistlePitch" | "BlastView" | "OppText" | "TattooCare" = blastView ? 'BlastView' : oppText ? 'OppText' : tattooCare ? 'TattooCare' : 'WhistlePitch';
const domains = {
  'BlastView': 'blastview.io',
  'WhistlePitch': 'whistlepitch.com',
  'OppText': 'ology.health',
  'TattooCare': 'whistlepitch.com'
}
const domain = domains[brand]

const subdomains = {
  'BlastView': 'app',
  'WhistlePitch': 'app',
  'OppText': 'app',
  'TattooCare': 'tattoo'
}
const subdomain = subdomains[brand]

const app_urls = {
  'BlastView': `https://${subdomains['BlastView']}.${domains['BlastView']}`,
  'WhistlePitch': `https://${subdomains['WhistlePitch']}.${domains['WhistlePitch']}`,
  'OppText': `https://${subdomains['OppText']}.${domains['OppText']}`,
  'TattooCare': `https://${subdomains['TattooCare']}.${domains['TattooCare']}`
}
const app_url = app_urls[brand]

const default_base_urls = {
  'BlastView': __DEV__ ? 'http://localhost:4000' : `https://api.${domain}`,
  // 'WhistlePitch': __DEV__ ? `https://api.${domain}` : `https://api.${domain}`,
  'WhistlePitch': __DEV__ ? 'http://localhost:4000' : `https://api.${domain}`,
 // 'OppText': `https://api.ology.health`,
  'OppText': __DEV__ ? 'http://localhost:4000' : `https://api.${domain}`,
  'TattooCare': __DEV__ ? 'http://localhost:4000' : `https://api.tattoo.${domain}`
}
const apiUrlOverride = (process.env.EXPO_API_URL || '').replace(/\/$/, '')
const base_urls = apiUrlOverride
  ? { ...default_base_urls, [brand]: apiUrlOverride }
  : default_base_urls
const base_url = base_urls[brand]

if (__DEV__) {
  console.log('Brand', brand)
  console.log(`WhistlePitch: ${whistlePitch}`)
  console.log(`BlastView: ${blastView} ${process.env.EXPO_BLAST_VIEW}`)
  console.log(`OppText: ${oppText} ${process.env.EXPO_OPP_TEXT}`)
  console.log(`TattooCare: ${tattooCare} ${process.env.EXPO_TATTOO_CARE}`)
}

let groupLink = tattooCare ? {
  "id": "sidebar-link-4",
  "label": "Landing Pages",
  "url": "/landing-pages",
  "icon": "m 9.818209,4.363632 c -0.215809,0 -0.4267019,0.06398 -0.6061066,0.183859 C 9.0327071,4.667357 8.8928831,4.8377378 8.8103137,5.037072 8.7277437,5.2364063 8.706144,5.455757 8.7482297,5.6673697 8.7903287,5.878992 8.8942264,6.073373 9.0467897,6.225936 9.1993624,6.378499 9.3937433,6.4824 9.6053753,6.524496 c 0.2115843,0.04209 0.4309447,0.02049 0.6302447,-0.06208 0.19939,-0.08257 0.36979,-0.2223939 0.4896,-0.4017889 0.1199,-0.179405 0.18384,-0.390317 0.18384,-0.606077 0,-0.2893248 -0.11492,-0.566803 -0.31949,-0.7713888 C 10.38499,4.478573 10.10755,4.363632 9.818209,4.363632 Z m -4.363662,0 c -0.21576,0 -0.4266813,0.06398 -0.6060767,0.183859 C 4.6690658,4.667357 4.5292418,4.8377378 4.4466818,5.037072 4.3641118,5.2364063 4.3425023,5.455757 4.3845988,5.6673697 4.4266948,5.878992 4.5305863,6.073373 4.6831588,6.225936 4.8357223,6.378499 5.0301028,6.4824 5.2417155,6.524496 5.453338,6.5665832 5.6726786,6.5449832 5.8720226,6.4624134 6.071357,6.379843 6.2417377,6.240019 6.361603,6.060624 6.4814783,5.881219 6.545453,5.670307 6.545453,5.454547 6.545453,5.1652223 6.4305217,4.887744 6.225936,4.6831583 6.0213503,4.478573 5.743872,4.363632 5.454547,4.363632 Z m 8.727243,0 c -0.21571,0 -0.42662,0.06398 -0.60605,0.183859 -0.17942,0.119866 -0.3192,0.2902468 -0.40176,0.489581 -0.08259,0.1993343 -0.10416,0.418685 -0.0621,0.6302977 0.04204,0.2116223 0.14602,0.4060033 0.29856,0.5585663 0.15255,0.152563 0.34695,0.256464 0.55853,0.29856 0.21168,0.04209 0.43104,0.02049 0.63034,-0.06208 0.19929,-0.08257 0.36969,-0.2223939 0.4896,-0.4017889 0.1198,-0.179405 0.18384,-0.390317 0.18384,-0.606077 0,-0.2893248 -0.11492,-0.566803 -0.31949,-0.7713888 C 14.74858,4.478573 14.47114,4.363632 14.18179,4.363632 Z M 20.72726,0 H 3.2727262 C 2.4047421,0 1.572317,0.34480419 0.95856,0.95856 0.34480419,1.572317 0,2.4047421 0,3.2727262 V 20.72726 C 0,21.5953 0.34480419,22.42771 0.95856,23.04144 1.572317,23.65517 2.4047421,24 3.2727262,24 H 20.72726 c 0.86804,0 1.70045,-0.34483 2.31418,-0.95856 C 23.65517,22.42771 24,21.5953 24,20.72726 V 3.2727262 C 24,2.4047421 23.65517,1.572317 23.04144,0.95856 22.42771,0.34480419 21.5953,0 20.72726,0 Z m 1.09095,20.72726 c 0,0.28935 -0.11501,0.56679 -0.31959,0.77136 -0.20457,0.20458 -0.48201,0.31959 -0.77136,0.31959 H 3.2727262 C 2.9834019,21.81821 2.705923,21.7032 2.5013379,21.49862 2.296752,21.29405 2.181821,21.01661 2.181821,20.72726 v -9.8182 H 21.81821 Z m 0,-11.9999863 H 2.181821 V 3.2727262 c 0,-0.2893243 0.114931,-0.5668032 0.3195169,-0.7713883 C 2.705923,2.296752 2.9834019,2.181821 3.2727262,2.181821 H 20.72726 c 0.28935,0 0.56679,0.114931 0.77136,0.3195169 0.20458,0.2045851 0.31959,0.482064 0.31959,0.7713883 z"
} : {
  "id": "sidebar-link-4",
  "label": "Groups",
  "url": "/groups",
  "icon": "M12.3 12.22A4.92 4.92 0 0 0 14 8.5a5 5 0 0 0-10 0 4.92 4.92 0 0 0 1.7 3.72A8 8 0 0 0 1 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM9 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm9.74.32A5 5 0 0 0 15 3.5a1 1 0 1 0 0 2 3 3 0 0 1 3 3 3 3 0 0 1-1.5 2.59 1 1 0 0 0-.05 1.7l.39.26.13.07a7 7 0 0 1 4 6.38 1 1 0 0 0 2 0 9 9 0 0 0-4.23-7.68Z"
}

const reportsLink = {
  "id": "sidebar-link-reports",
  "label": "Reports",
  "url": "/reports",
  "icon": "M3 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7.83a1 1 0 0 0-.29-.71l-5.83-5.83A1 1 0 0 0 15.17 1H3Zm1 2h10v4a1 1 0 0 0 1 1h4v10H4Zm4 3a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9A1 1 0 0 0 8 8Zm4 2a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1Zm4 2a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1Z"
}

const aiLink = {
  "id": "sidebar-link-ai",
  "label": "AI",
  "url": "/ai",
  "icon": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 4.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm0 11a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm5.5-5.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm-11 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm7-3.89 2.83-2.83a1 1 0 0 1 1.41 1.41l-2.83 2.83a3.5 3.5 0 0 0-2.9 0L8.26 5.19a1 1 0 1 1 1.41-1.41l2.83 2.83a3.5 3.5 0 0 0 1 0ZM8.24 13.69l-2.83 2.83a1 1 0 0 1-1.41-1.41l2.83-2.83a3.5 3.5 0 0 0 2.9 0l2.83 2.83a1 1 0 0 1-1.41 1.41l-2.83-2.83a3.5 3.5 0 0 0-1 0Z"
}

const aiTestLink = {
  "id": "sidebar-link-ai-test",
  "label": "AI Test",
  "url": "/ai-test",
  "icon": "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 4.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm0 11a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm5.5-5.5a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm-11 0a1 1 0 1 1-1 1 1 1 0 0 1 1-1Zm7-3.89 2.83-2.83a1 1 0 0 1 1.41 1.41l-2.83 2.83a3.5 3.5 0 0 0-2.9 0L8.26 5.19a1 1 0 1 1 1.41-1.41l2.83 2.83a3.5 3.5 0 0 0 1 0ZM8.24 13.69l-2.83 2.83a1 1 0 0 1-1.41-1.41l2.83-2.83a3.5 3.5 0 0 0 2.9 0l2.83 2.83a1 1 0 0 1-1.41 1.41l-2.83-2.83a3.5 3.5 0 0 0-1 0Z"
}

const plansLink = {
  "id": "sidebar-link-plans",
  "label": "Plans",
  "url": "/plans",
  "icon": "M20 4H4a2 2 0 0 0-2 2v3h20V6a2 2 0 0 0-2-2zm2 7H2v7a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-7zM6 16h5v2H6v-2z"
}

const composeLink = {
  "id": "sidebar-link-compose",
  "label": "Compose",
  "url": "/compose",
  "icon": "M21.44 2.56a1.5 1.5 0 0 0-1.63-.27L3.3 10.14a1.5 1.5 0 0 0 .08 2.77l6.54 2.18 2.18 6.54a1.5 1.5 0 0 0 2.77.08l7.85-16.51a1.5 1.5 0 0 0-.28-1.64ZM14.1 19.12l-1.57-4.7 3.54-3.54a1 1 0 1 0-1.41-1.41l-3.54 3.54-4.7-1.57 12.39-5.9Z"
}

// let bodyPartsLink = {
//   "id": "sidebar-link-6",
//   "label": "Body Parts",
//   "url": "/body-parts",
//   "icon": "m 8.25,2.2500006 v 5.2499992 h -6 V 2.2500006 Z M 2.25,0 C 1.0078125,0 0,1.0078127 0,2.2500006 V 7.4999998 C 0,8.7421877 1.0078125,9.75 2.25,9.75 h 6 c 1.2421876,0 2.25,-1.0078123 2.25,-2.2500002 V 2.2500006 C 10.5,1.0078127 9.4921876,0 8.25,0 Z m 6,13.5 v 5.25 h -6 V 13.5 Z m -6,-2.25 C 1.0078125,11.25 0,12.257813 0,13.5 v 5.25 C 0,19.992188 1.0078125,21 2.25,21 h 6 c 1.2421876,0 2.25,-1.007812 2.25,-2.25 V 13.5 c 0,-1.242187 -1.0078124,-2.25 -2.25,-2.25 z m 12,-8.9999994 h 7.5 v 1.4999997 h -7.5 z m -2.25,0 V 3.7500003 C 12,4.9921873 13.007813,6 14.25,6 h 7.5 C 22.992187,6 24,4.9921873 24,3.7500003 V 2.2500006 C 24,1.0078127 22.992187,0 21.75,0 h -7.5 C 13.007813,0 12,1.0078127 12,2.2500006 Z M 21.75,9.75 v 1.5 h -7.5 V 9.75 Z M 14.25,7.4999998 C 13.007813,7.4999998 12,8.5078125 12,9.75 v 1.5 c 0,1.242188 1.007813,2.25 2.25,2.25 h 7.5 C 22.992187,13.5 24,12.492188 24,11.25 V 9.75 C 24,8.5078125 22.992187,7.4999998 21.75,7.4999998 Z m 0,9.7500002 h 7.5 v 1.5 h -7.5 z m -2.25,0 v 1.5 c 0,1.242188 1.007813,2.25 2.25,2.25 h 7.5 C 22.992187,21 24,19.992188 24,18.75 v -1.5 C 24,16.007813 22.992187,15 21.75,15 h -7.5 C 13.007813,15 12,16.007813 12,17.25 Z"
// }
let actionTwoText = blastView ? 'New Group' : 'Add Contacts';
actionTwoText = whistlePitch ? 'Add Leads' : actionTwoText;

export default {
  version: 'v3.4.7',
  api: base_url + '/graphql',
  base_oauth2: base_url + '/oauth2',
  domain: domain,
  base_url: base_url,
  base_urls: base_urls,
  brand: 'Ology Health',
  brand_key: brand.toLowerCase(),
  app_url: __DEV__ ? 'http://localhost:19006' : app_url,
  app_urls: app_urls,
  tirUrl: base_url + '/tir/',
  stripePk: __DEV__ ? 'pk_test_gpGr64iRpqJtF0rGBV4YoD7p00A4cu9sRP' : 'pk_live_xqEJujdE8M2sWzBEaP3buY6D00Y5wXeADB',
  // stripePk: __DEV__ ? 'pk_live_xqEJujdE8M2sWzBEaP3buY6D00Y5wXeADB' : 'pk_live_xqEJujdE8M2sWzBEaP3buY6D00Y5wXeADB',
  whistlePitch: whistlePitch,
  blastView: blastView,
  oppText: oppText,
  tattooCare: tattooCare,
  colors: {
    white: '#FFFFFF',
    blue: '#1E58F0',
    darkBlue: '#102A9C',
    mediumBlue: '#7295FF',
    lightBlue: '#E8EBF9',

    red: '#B63070',
    darkRed: '#d00a55',
    lightRed: '#F3DFEB',

    green: '#87BE12',
    darkGreen: '#417f06',
    lightGreen: '#53E022',

    purple: '#5043FF',
    darkPurple: '#3f15bc',
    lightPurple: '#ece9ff',

    yellow: '#FFBC00',
    darkYellow: '#d3991a',
    lightYellow: '#fff5d9',

    pink: '#E35261',
    darkPink: '#E35261',
    lightPink: '#E35261',

    grey: '#acadb0',
    darkGrey: '#828385',
    mediumGrey: '#CCCDCD',
    lightGrey: '#dcdde0',

    primary: '#3961e5',
    primaryMedium: '#8ea7f7',
    primaryLight: '#bacfff',
    accent: '#4d4cac',
    accentMedium: '#8381c5',
    accentLight: '#9698d6',
    secondary: '#828385',
    secondaryLight: '#e8eaf6',
    light: '#f5f6fc',
    info: '#acadb0',
    infoLight: '#dcdde0',
    dark: '#1b1b1c',
    dangerDark: '#e66a76',
    danger: '#ff808b',
    dangerMedium: '#fea5ae',
    dangerLight: '#ffb3ba',
    successDark: '#76c660',
    success: '#aedea2',
    successLight: '#d3f0cb',
    warning: '#ffab1d',
    warningLight: '#ffd085',
    backgroundLight: '#F7F8FA'
  },
  sidebarStructure: [
    {
      "id": "sidebar-link-1",
      "label": "Overview",
      "url": "/dashboard",
      "icon": "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 1 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
    },
    {
      "id": "sidebar-link-2",
      "label": blastView ? "Blasts" : "Campaigns",
      "url": "/campaigns",
      "icon": "M19.991 2.002a1 1 0 0 0-1 1v.637a9.036 9.036 0 0 1-7 3.363h-6a3.003 3.003 0 0 0-3 3v2a3.003 3.003 0 0 0 3 3h.484l-2.403 5.606a.999.999 0 0 0 .92 1.394h4a.999.999 0 0 0 .918-.607l2.724-6.355a9.026 9.026 0 0 1 6.357 3.325v.637a1 1 0 0 0 2 0v-16a.998.998 0 0 0-1-1Zm-14 11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v4h-1Zm2.341 7H6.508l2.142-5h1.825l-2.143 5Zm10.66-4.478a11.052 11.052 0 0 0-7-2.522h-3v-4h3a11.053 11.053 0 0 0 7-2.522v9.044Z"
    },
    ...(oppText ? [] : [groupLink]),
    // ...(tattooCare ? [bodyPartsLink] : []),
  ],
  sidebarStructureWithMessages: [
    {
      "id": "sidebar-link-1",
      "label": "Overview",
      "url": "/dashboard",
      "icon": "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 1 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
    },
    {
      "id": "sidebar-link-2",
      "label": blastView ? "Blasts" : "Campaigns",
      "url": "/campaigns",
      "icon": "M19.991 2.002a1 1 0 0 0-1 1v.637a9.036 9.036 0 0 1-7 3.363h-6a3.003 3.003 0 0 0-3 3v2a3.003 3.003 0 0 0 3 3h.484l-2.403 5.606a.999.999 0 0 0 .92 1.394h4a.999.999 0 0 0 .918-.607l2.724-6.355a9.026 9.026 0 0 1 6.357 3.325v.637a1 1 0 0 0 2 0v-16a.998.998 0 0 0-1-1Zm-14 11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v4h-1Zm2.341 7H6.508l2.142-5h1.825l-2.143 5Zm10.66-4.478a11.052 11.052 0 0 0-7-2.522h-3v-4h3a11.053 11.053 0 0 0 7-2.522v9.044Z"
    },
    ...(oppText ? [] : [groupLink]),
    // ...(tattooCare ? [bodyPartsLink] : []),
    {
      "id": "sidebar-link-5",
      "label": "Messages",
      "url": "/messages",
      "icon": "M13 11H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-4H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1.001 1.001 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z"
    },
    composeLink,
  ],
  sidebarStructureV2: [
    {
      "id": "sidebar-link-1",
      "label": "Overview",
      "url": "/dashboard",
      "icon": "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 1 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
    },
    ...(oppText ? [] : [groupLink]),
    {
      "id": "sidebar-link-5",
      "label": "Messages",
      "url": "/messages",
      "icon": "M13 11H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-4H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1.001 1.001 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z"
    },
    composeLink,
  ],
  sidebarStructureAdmin: [
    {
      "id": "sidebar-link-1",
      "label": "Overview",
      "url": "/dashboard",
      "icon": "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 1 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
    },
    {
      "id": "sidebar-link-2",
      "label": blastView ? "Blasts" : "Campaigns",
      "url": "/campaigns",
      "icon": "M19.991 2.002a1 1 0 0 0-1 1v.637a9.036 9.036 0 0 1-7 3.363h-6a3.003 3.003 0 0 0-3 3v2a3.003 3.003 0 0 0 3 3h.484l-2.403 5.606a.999.999 0 0 0 .92 1.394h4a.999.999 0 0 0 .918-.607l2.724-6.355a9.026 9.026 0 0 1 6.357 3.325v.637a1 1 0 0 0 2 0v-16a.998.998 0 0 0-1-1Zm-14 11a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1v4h-1Zm2.341 7H6.508l2.142-5h1.825l-2.143 5Zm10.66-4.478a11.052 11.052 0 0 0-7-2.522h-3v-4h3a11.053 11.053 0 0 0 7-2.522v9.044Z"
    },
    ...(oppText ? [] : [groupLink]),
    // ...(tattooCare ? [bodyPartsLink] : []),
    {
      "id": "sidebar-link-5",
      "label": "Messages",
      "url": "/messages",
      "icon": "M13 11H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-4H7a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2Zm2-5H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71A1 1 0 0 0 21 22a.84.84 0 0 0 .38-.08A1 1 0 0 0 22 21V5a3 3 0 0 0-3-3Zm1 16.59-2.29-2.3A1.001 1.001 0 0 0 17 16H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.59Z"
    },
    composeLink,
  ],
  sidebarStructureLimited: [{
    "id": "sidebar-link-1",
    "label": "Overview",
    "url": "/dashboard",
    "icon": "M21 20h-1V5a1 1 0 0 0-2 0v15h-2V9a1 1 0 0 0-2 0v11h-2v-7a1 1 0 0 0-2 0v7H8v-3a1 1 0 1 0-2 0v3H4V3a1 1 0 0 0-2 0v18a1 1 0 0 0 1 1h18a1 1 0 0 0 0-2Z"
  }],
  sidebarEventsPage: {
    "id": "sidebar-link-6",
    "label": "Events",
    "url": "/events",
    "icon": "m 4.9160156,1.0410156 v 0.8847656 c -0.6958502,0.00184 -1.3898841,-0.00158 -2.0859375,0.00195 h -0.037109 l -0.035156,0.00195 C 0.86902329,2.0634312 -0.30614887,3.8558352 -0.07226562,5.5820312 L -0.08398437,5.4335937 C -0.07713104,10.033429 -0.09636058,14.638863 -0.07226562,19.25 v 0.03711 l 0.0019531,0.03711 c 0.13374431,1.888789 1.9281003,3.063962 3.6542969,2.830078 l -0.1503906,0.0098 c 4.599822,-0.0069 9.2072162,0.01433 13.8183592,-0.0098 h 0.03711 l 0.03516,-0.002 c 1.888799,-0.133735 3.063964,-1.928103 2.830078,-3.654297 l 0.01172,0.15039 c -0.0069,-4.599822 0.01238,-9.2072146 -0.01172,-13.8183589 v -0.042969 l -0.0039,-0.044922 C 20.015628,3.1210058 18.645356,1.8835009 17.017578,1.9160156 c -0.616417,8.821e-4 -1.234932,0.00184 -1.851562,0.00195 V 1.0410156 h -2.25 v 0.8789063 c -1.915707,-0.00122 -3.8324917,0.00248 -5.7500004,0.00391 V 1.0410156 Z M 17.042969,4.1640625 h 0.0098 0.0098 c 0.367602,-0.00734 0.809299,0.3949634 0.84375,0.7617187 0.0051,0.9954053 2.8e-4,1.9941917 0.002,2.9902344 H 2.1679688 C 2.1680911,7.0865221 2.167252,6.2595272 2.1660156,5.4296875 L 2.1640625,5.3554687 2.1542969,5.28125 C 2.0868711,4.7836082 2.4598404,4.2132388 2.9101563,4.1757812 c 0.667713,-0.00333 1.3378791,-1.83e-4 2.0058593,-0.00195 v 0.8671875 h 2.25 V 4.171875 c 1.9156571,-0.00143 3.8324044,-0.00512 5.7500004,-0.00391 v 0.8730469 h 2.25 v -0.875 c 0.62618,-1.149e-4 1.250593,-0.00105 1.876953,-0.00195 z M 2.1699219,10.164063 H 17.910156 c 2.05e-4,2.828074 0.0016,5.653913 0.0059,8.486328 l 0.002,0.07617 0.0098,0.07422 c 0.06764,0.499221 -0.30752,1.071298 -0.759765,1.105469 -4.572614,0.02343 -9.1536135,0.0029 -13.7382815,0.0098 h -0.074219 l -0.074219,0.0098 c -0.4976413,0.06743 -1.068011,-0.303589 -1.1054687,-0.753906 -0.01539,-2.998561 -0.00813,-6.00381 -0.00586,-9.007812 z"
  },
  controls: {
    integrations: false, //oppText,
    showRedirect: whistlePitch || tattooCare,
    allowSlideTypeCalendly: whistlePitch,
    allowSlideTypeYoutube: !blastView,
    allowSlideTypeAudio: false, //blastView,
    allowSlideTypeText: oppText || tattooCare,
    allowSlides: !blastView,
    allowIfThen: !blastView,
    allowIncomingLeads: oppText,
    allowSelfOnboarding: oppText,
    allowCampaignLandingPage: whistlePitch,
    allowCallForwarding: !blastView,
    allowAutoReply: oppText,
    requireBillingBeforeProceed: false // Set to true for brands that require billing before accessing the app
  },

  localizations: {
    Lead: blastView || oppText ? 'Contact' : tattooCare ? 'Client' : 'Lead',
    Leads: blastView || oppText ? 'Contacts' : tattooCare ? 'Clients' : 'Leads',
    lead: blastView || oppText ? 'contact' : tattooCare ? 'client' : 'lead',
    leads: blastView || oppText ? 'contacts' : tattooCare ? 'clients' : 'leads',
    pitch: oppText ? 'content' : 'pitch',
    pitches: oppText ? 'content' : 'pitches',
    Campaign: blastView ? 'Blast' : 'Campaign',
    Campaigns: blastView ? 'Blasts' : 'Campaigns',
    campaign: blastView ? 'blast' : 'campaign',
    campaigns: blastView ? 'blasts' : 'campaigns',
    actionOneText: blastView ? 'New Blast' : 'New Campaign',
    actionTwoText: actionTwoText,
    optIn: oppText ? 'I opt-in to receiving communications at the number provided. (You may opt-out at any time by replying STOP)' : tattooCare ? 'The client has agreed to share their phone number with yourself and with TattooCare' : 'I agree to receive additional communications.',
    Branding: oppText ? 'Organization' : 'Branding',
    Brand: oppText ? 'Organization' : 'Brand',
  },

  dropdownOptions: blastView ? [{ id: 'account', label: 'Account', value: 'account' }] : [{ id: 'users', label: 'Users', value: 'users' }, { id: 'account', label: 'Account', value: 'account' }],
  dropdownOptionsWpAdmin: blastView ? [{ id: 'account', label: 'Account', value: 'account' }] : oppText ? [{ id: 'users', label: 'Users', value: 'users' }, { id: 'account', label: 'Account', value: 'account' }] : [{ id: 'users', label: 'Users', value: 'users' }, { id: 'account', label: 'Account', value: 'account' }, { id: 'metrics', label: 'Engagement Metrics', value: 'metrics' }],
  dropdownOptionsLimited: [{ id: 'account', label: 'Account', value: 'account' }],

  // J Test facebookPixelId: '860972008404994',
  facebookPixelId: '1027949663904183',
  reportsSidebarLink: reportsLink,
  plansSidebarLink: plansLink,
  aiSidebarLink: aiLink,
  aiTestSidebarLink: aiTestLink,
  composeSidebarLink: composeLink
}
